import { render, staticRenderFns } from "./OfflineIndicator.vue?vue&type=template&id=a52013f2"
import script from "./OfflineIndicator.vue?vue&type=script&lang=js"
export * from "./OfflineIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports